import React, {Component} from 'react'
import {Redirect} from 'react-router-dom'


class BottomPanel extends Component{
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
        }
    }

    handleClick = () => {
        let {actionType} = this.props;
        if (actionType === 'button') {
            this.setState({redirect: true})
        }else{
            return this.props.handleClick(1);
        }

    };

    render() {
        let displayPanel = (this.props.hidden)?'none':'';
        let {title, actionContent, actionType} = this.props;

        if(this.state.redirect && actionType === 'button'){
            return <Redirect to={'/'+actionContent} />;
        }

        return(
            <div className='bottom-box' style={{display: displayPanel}}>
                <button onClick={this.handleClick} type={actionType} className="ant-btn btn-next-action"><span>{title}</span></button>
            </div>
        )
    }
}

export default BottomPanel;